import { render } from "./Orb.vue?vue&type=template&id=4bf37072&scoped=true"
import script from "./Orb.vue?vue&type=script&lang=js"
export * from "./Orb.vue?vue&type=script&lang=js"

import "./Orb.vue?vue&type=style&index=0&id=4bf37072&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf37072"]])

export default __exports__